
import Vue from 'vue';
import _isEmpty from 'lodash/isEmpty';
import { mapActions, mapState } from 'vuex';
import { RunnitDynamicFieldMixin } from '@/views/Runnits/RunnitSettings/mixins/RunnitDynamicFieldMixin';
import { getLogicOnFieldsFromField } from '@run-diffusion/shared';
import _isNil from 'lodash/isNil';
import MenuOrBottomSheet from '@/components/base/MenuOrBottomSheet.vue';
import RunnitDynamicFieldLabelRow from '@/views/Runnits/RunnitSettings/RunnitDynamicFieldLabelRow.vue';
import ComplexBackgroundBaseStyledMenu from '@/components/designElements/ComplexBackgroundBaseStyledMenu.vue';
import RunnitMenuOrBottomSheet from '../../base/RunnitMenuOrBottomSheet.vue';
import ImageSearchDialogSelect from './ImageSearchDialogSelect.vue';
import { SNACKBAR_STATUS } from '@/constants/constants';

export default Vue.extend({
	name: 'RunnitSingleSelect',
	mixins: [
		RunnitDynamicFieldMixin,
	],
	props: {
		field: { type: Object, required: true },
		value: { type: [Number, String, Object, Array], default: null },
		adminOnly: { type: Boolean, default: false },
		labelStyles: { type: Object, default: null },
		inputValues: { type: Object, required: true },
	},
	data () {
		return {
			imageSelectOpen: false,
		};
	},
	computed: {
		...mapState([
			'runnitState',
		]),
		logicOnFields () {
			return getLogicOnFieldsFromField(this.field, this.inputValues);
		},
		autoSetValue () {
			return this.logicOnFields.autoSetValue;
		},
		autoSetError () {
			return this.logicOnFields.autoSetError;
		},
		localValue () {
			let value = this.value ? this.options.find((option) => option.value === this.value) : null

			return value;
		},
		useImageSelect () {
			return !_isEmpty(this._get(this.field, 'display.image'));
		},
		useImageDialog () {
			return this._get(this.field, 'display.image.dialogSelect') && !this._get(this.field, 'display.image.searchableDialog');
		},
		useImageSearchableDialog () {
			return this._get(this.field, 'display.image.dialogSelect') && this._get(this.field, 'display.image.searchableDialog');
		},
		imageMinWidth () {
			return this._get(this.field, 'display.image.imageMinWidth');
		},
		useRadioSelect () {
			return !_isEmpty(this._get(this.field, 'display.radio'));
		},
		useTextSelect () {
			return !_isEmpty(this._get(this.field, 'display.text'));
		},
		options () {
			if (this.useImageSelect) return this._get(this.field, 'display.image.options');
			if (this.useRadioSelect) return this._get(this.field, 'display.radio.options');
			if (this.useTextSelect) return this._get(this.field, 'display.text.options');
			return this._get(this.field, 'display.options') || []; // backwards compatible with old text select
		},

	},
	watch: {
		autoSetValue: {
			handler (newValue: any, oldValue: any) {
				if (_isNil(newValue) || newValue === oldValue) return;

				const options = this.options || [];
				const match = options.find((option: any) => option && option.value === newValue);

				if (match) {
					this.emitInput(match.value);
				} else {
					this.updateSnackbar({
						status: SNACKBAR_STATUS.ERROR,
						message: this.autoSetError || 'Auto-set value did not match an available option.',
						show: true,
					});
				}
			},
			immediate: true,
		},
		autoSetError: {
			handler (newVal: string, oldVal: string) {
				if (newVal && newVal !== oldVal) {
					this.updateSnackbar({
						status: SNACKBAR_STATUS.ERROR,
						message: newVal,
						show: true,
					});
				}
			},
			immediate: true,
		},
	},
	methods: {
		...mapActions([
			'updateRunnitState',
			'updateSnackbar',
		]),

		emitInput (value: string) {
			this.$emit('input', value);
		},
		onSelectImageOption (option: any, close: Function) {
			this.emitInput(option.value);
			if (close) {
				close();
			}
		},
		openImageSelect () {
			this.updateRunnitState({
				imageSelectOpen: true,
				// Close all other potentially open runnit menus
				promptGeneratorOpen: false,
				// Clear all field-specific inpainting editors
				inpaintingEditorStates: {},
			});
		},
		closeImageSelect () {
			this.updateRunnitState({
				imageSelectOpen: false,
			});
		},
	},
	components: {
		ComplexBackgroundBaseStyledMenu,
		MenuOrBottomSheet,
		RunnitDynamicFieldLabelRow,
		RunnitMenuOrBottomSheet,
		ImageSearchDialogSelect,
	},
});
